import { render, staticRenderFns } from "./RestaurantDetails.vue?vue&type=template&id=220e49e4"
import script from "./RestaurantDetails.vue?vue&type=script&lang=js"
export * from "./RestaurantDetails.vue?vue&type=script&lang=js"
import style0 from "./RestaurantDetails.vue?vue&type=style&index=0&id=220e49e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports